import { IS_DEV_MODE, IS_DEPLOYMENT_MODE, IS_ATLAS_BUILD } from "./env";

export const APP_HOST = !IS_DEPLOYMENT_MODE ? "https://my.securityjourney.dev" : "";
export const AFTER_SIGN_OUT_PATH = IS_ATLAS_BUILD ? "/login/signed-out" : "/logged-out";
export const SIGNED_OUT_PAGE = "/login/signed-out";

export const AWS_COGNITO_REDIRECT_URI =
  import.meta.env.VITE_APP_AWS_COGNITO_REDIRECT_URI || `${window.location.origin}/auth`;

export const AWS_COGNITO_SJ_ADMIN_REDIRECT_URI =
  import.meta.env.VITE_APP_AWS_COGNITO_SJ_ADMIN_REDIRECT_URI ||
  `${window.location.origin}/sj_admin_auth`;

export const scimApiUrl = (tenantName: string) => {
  if (IS_DEV_MODE) {
    return `https://api.securityjourney.dev/scim/${tenantName}/v2`;
  } else {
    return `https://api.securityjourney.com/scim/${tenantName}/v2`;
  }
};
